<template>
  <div id="section1">
    <div class="fondoWhite">
      <b-container fluid>
        <b-container class="text-center pt-5">
          <br>
          <h2>
            {{ $t("p9s1title1") }}
          </h2>
          <br>
          <p class="text-left">
            {{ $t("p9s1desc1") }}
          </p>
          <br>
        </b-container>
      </b-container>
    </div>
  </div>
</template>

<i18n>
{
  "en":{
    "p9s1title1": "Universities and collaborating institutions of AICAD Business School",
    "p9s1desc1":  "AICAD Business School has constantly collaborated with universities, hospitality and catering schools, other business schools, technical education centers, foundations, international mobility institutions and an endless number of organizations since its foundation, which has made it possible for many students to find international internships, the best learning experience and take the first steps in the labor world. Below, you may find some of our partner organizations."
  },
  "es":{
    "p9s1title1": "Universidades e instituciones colaboradoras de AICAD Business School",
    "p9s1desc1":  "AICAD Business School ha colaborado constantemente con universidades, escuelas de hostelería y restauración, otros Business School, centros de enseñanza técnica, fundaciones, instituciones de movilidad internacional y un sin fin de organismos desde su fundación, lo cual ha hecho posible que muchos estudiantes encuentren prácticas internacionales y tengan la mejor experiencia de aprendizaje y un primer acercamiento al mundo laboral. A continuación, verás algunas de dichas organizaciones colaboradoras."
  }
}
</i18n>

<script>
export default {
    data() {
        return {
      
        }
    }
};
</script>
